import { ICReport } from '@fortem-monorepo/web-sdk'

/**
 * Query key factory for IC Report
 */
export const queryKeys = {
  all: 'ic_report' as const,
  endpoint: (endpoint: ICReport.GetICReportDataParams['endpoint']) => {
    return [queryKeys.all, endpoint] as const
  },
  detail: (
    endpoint: ICReport.GetICReportDataParams['endpoint'],
    params: Omit<ICReport.GetICReportDataParams, 'endpoint'>,
  ) => {
    return [queryKeys.all, endpoint, params]
  },
}
